/** @type {import('@vue/compat').ComponentOptions} */
export default {
    data:{
        list:[],
        index:0,
        post_id:qk_global.post_id,
    },
    mounted(){
        if(!this.$refs.videoChapters) return
        this.$http.post(qk_rest_url+'getVideoList','post_id='+this.post_id).then(res=>{
            this.list = res.data.list;
        }).catch((err) => {
            qkShowApiError(err, '加载章节失败');
        })

    },
    methods:{
        
    }
};
